import {
  Component,
  ContentChild,
  AfterContentInit,
  Input,
} from "@angular/core";
import { WizardSubstep } from "./wizard-subtep.interface";

@Component({
  selector: "icn-wizard-substep",
  template:
    '<h3 *ngIf="!!title">{{title}}</h3><ng-content select=".wizard-substep-title"></ng-content><ng-content></ng-content>',
  styleUrls: ["./wizard-substep.component.scss"],
  host: {
    "[class.active]": "isCurrent",
  },
})
export class WizardSubstepComponent implements AfterContentInit {
  isCurrent: boolean;
  substepIndex: number;

  @Input()
  title: string;

  @ContentChild("substepContent") content: WizardSubstep;

  canGoNext() {
    return this.content.canGoNext();
  }

  ngAfterContentInit() {
    if (!this.content) {
      throw new Error(
        "No element with template id #substepContent found in wizard-substep",
      );
    }
  }
}
